import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetEvaluations = (periodId) => {
  const query = useApiQuery(
    ['courseAssignmentEvaluations', periodId],
    'schools',
    client => client.get(`/current-organization/course-assignment/periods/${periodId}/evaluations`),
    { enabled: !!periodId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    evaluations: query.data?.evaluations ?? [],
    error: query.error,
    refetch: query.refetch
  }
}
